import { Select, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { BookingStatus } from '@/models';
import { getStatusColor } from '@/utils';

type SelectMultipleBookingStatusProps = {
  selectedStatus: BookingStatus[];
  status: BookingStatus[];
  onChange: (value: BookingStatus[]) => void;
  disabled?: boolean;
};

export const SelectMultipleBookingStatus = ({
  selectedStatus,
  status,
  onChange,
  disabled,
}: SelectMultipleBookingStatusProps) => {
  const { t } = useTranslation();

  return (
    <Select
      aria-label='Status filtern'
      mode='multiple'
      value={selectedStatus}
      popupMatchSelectWidth={false}
      disabled={disabled}
      showSearch={{
        filterOption: (input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        optionFilterProp: 'children',
      }}
      placeholder={t('common:status')}
      maxTagCount={'responsive'}
      options={status.map((s) => ({
        value: s,
        label: t(`common:${s}`),
      }))}
      optionRender={(option) => (
        <Tag color={getStatusColor(option.value as BookingStatus)}>{option.label}</Tag>
      )}
      onChange={onChange}
      onClear={() => onChange([])}
      allowClear
      style={{ width: 100 }}
    />
  );
};
